export default function CsharpAccessModifiers() {
  return (
    <h2>Csharp Access Modifiers</h2>
  );
}
